export enum TicketTransport {
    VIDEOCHAT = 'videochat',
    CHAT = 'chat'
}
